module.exports = __webpack_public_path__ + "assets/img/SISTER3.975d66f9.png";